import { render } from "./EditTop.vue?vue&type=template&id=6ba5a7b7"
import script from "./EditTop.vue?vue&type=script&lang=js"
export * from "./EditTop.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__